function removeSeconds(timeString) {
  // Destructure the time string into parts
  const [hours, minutes] = timeString.split(":");
  // Return the hours and minutes combined
  return `${hours}:${minutes}`;
}

export default removeSeconds;
